import { enableNetwork, getAllDevices, requestActivateSubscription, requestUnlinkTracker } from '../../api/devices.api'
import { activeTestFleet } from '../../shared/testFleet'

const state = {
  trackers: [],
  selectedTracker: null,
  mac: null,
  boardName: null,
  loading: false,
}

const getters = {
  getDevices(state) {
    return state.trackers
  },
  getDevicesLoading(state) {
    return state.loading
  },
  getSelectedDevice(state) {
    return state.selectedTracker
  },
  isSelectedDeviceSubscriptionActive(state) {
    return state.selectedTracker?.tracker_status.sub_end_date && new Date(state.selectedTracker.tracker_status.sub_end_date) >= new Date()
  },
  getMac(state) {
    return state.mac
  },
  getBoardName(state) {
    return state.boardName
  },
}

const actions = {
  async fetchDevices({ commit }, type) {
    commit('SET_DEVICES_LOADING', true)
    try {
      const response = await getAllDevices(type)
      const data = activeTestFleet()?.devices ?? response.data
      commit(
        'SET_DEVICES',
        data.sort(function (a, b) {
          if (
            (a.tracker_status.sub_state == 'not_activated' && b.tracker_status.sub_state != 'not_activated') ||
            (b.tracker_status.sub_state == 'not_activated' && a.tracker_status.sub_state != 'not_activated')
          ) {
            return -1
          } else if (new Date(a.tracker_status.sub_end_date) > new Date(b.tracker_status.sub_end_date)) return 1
          else if (new Date(a.tracker_status.sub_end_date) < new Date(b.tracker_status.sub_end_date)) return -1
          return 0
        }),
      )
    } catch (error) {
      console.error('fetchDevices', error)
      // Re-throw so callers can distinguish a failed fetch from a genuinely empty
      // fleet — otherwise an owner with devices is shown the "no devices" onboarding.
      throw error
    } finally {
      commit('SET_DEVICES_LOADING', false)
    }
  },
  async postUnlinkTracker({ commit }, data) {
    try {
      const response = await requestUnlinkTracker(data)
      return response
    } catch (error) {
      console.error('postUnlinkTracker', error, error.response?.data)
      return error.response.data
    }
  },
  async enableNetwork({ commit }, data) {
    try {
      const response = await enableNetwork(data.id)
      return response.status >= 200 && response.status < 300
    } catch (error) {
      console.warn('enableNetwork', error)
      return error.status === 204
    }
  },
  async postActivateSubscription({ commit }, data) {
    try {
      const response = await requestActivateSubscription(data)
      return response
    } catch (error) {
      return error.response
    }
  },
  async setSelectedDevice({ commit }, data) {
    commit('SET_SELECTEDDEVICE', data)
  },
  async removeDevices({ commit }) {
    commit('REMOVE_DEVICES')
  },
  async removeSelectedDevice({ commit }) {
    commit('REMOVE_SELECTEDDEVICE')
  },
  async setMac({ commit }, data) {
    commit('SET_MAC', data)
  },
  async setBoardName({ commit }, data) {
    commit('SET_BOARDNAME', data)
  },
}

const mutations = {
  SET_DEVICES(state, data) {
    state.trackers = data
  },
  SET_DEVICES_LOADING(state, value) {
    state.loading = value
  },
  REMOVE_DEVICES(state) {
    state.trackers = []
  },
  SET_SELECTEDDEVICE(state, data) {
    if (data?.price) {
      data.price = { meta_data: { months: 0 } }
    }
    state.selectedTracker = data
  },
  REMOVE_SELECTEDDEVICE(state) {
    state.selectedTracker = null
  },
  SET_MAC(state, data) {
    state.mac = data
  },
  REMOVE_MAC(state) {
    state.mac = null
  },
  SET_BOARDNAME(state, data) {
    state.boardName = data
    localStorage.setItem('boardName', data)
  },
  REMOVE_BOARDNAME(state) {
    state.boardName = null
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
